import React from 'react';
import { useTranslation } from 'react-i18next';
import { Package } from 'lucide-react';
import { SiteLayout, useDocumentTitle } from '../components/platform/SiteLayout';
import { Container, Heading, CardSkeletons, EmptyState, ErrorState } from '../components/platform/ui';
import ProductCard from '../components/platform/ProductCard';
import useAsync from '../hooks/useAsync';
import { platformApi } from '../services/platformApi';

const CatalogPage = () => {
  const { t, i18n } = useTranslation();
  useDocumentTitle(t('pl.catalog.pageTitle'));
  const { data, loading, error, reload } = useAsync(platformApi.products, [i18n.language]);
  return (
    <SiteLayout>
      <Container className="py-12">
        <Heading level={1} className="text-4xl sm:text-5xl mb-3">{t('pl.catalog.title')}</Heading>
        <p className="text-gray-700 max-w-3xl mb-10">{t('pl.catalog.subtitle')}</p>
        {loading ? <CardSkeletons /> : error ? <ErrorState onRetry={reload} /> : data.length === 0 ? (
          <EmptyState icon={Package} title={t('pl.catalog.emptyTitle')} text={t('pl.catalog.emptyText')} />
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {data.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </Container>
    </SiteLayout>
  );
};

export default CatalogPage;
